import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  rootBanner: {
    flexGrow: 1,
    marginTop: "5px",
    marginBottom: "-75px",
  },
  container: {
    padding: "10px",
    borderRadius: "10px",
    // marginTop: "20px",
    // marginBottom: "30px",
  },
  wrapKatalog: {
    // marginTop: 20,
    padding: 10,
    // backgroundColor:"#EFF1FF"
  },
  hero: {
    height: "400px",
    objectFit: "cover",
    width: "100%",
    "@media (max-width: 768px)": {
      height: "350px",
    },
    "@media (max-width: 480px)": {
      height: "250px",
    },
  },
  skeleton: {
    height: "500px",
    width: "100%",
    "@media (max-width: 768px)": {
      height: "300px",
    },
    "@media (max-width: 480px)": {
      height: "300px",
    },
  },
  wrapLeaderboard: {
    justifyContent: "center",
    padding: "10px 0px",
  },
  wrapItem: {
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#5675D3",
    borderRadius: "10px",
    boxShadow: "0px 5px 10px #42424359",
    "@media (max-width: 480px)": {
      height: "125px",
    },
  },
  wrapItemLight: {
    padding: "15px",
    textAlign: "center",
    backgroundColor: "#AABBE9",
    borderRadius: "10px",
    boxShadow: "0px 5px 10px #42424359",
    "@media (max-width: 480px)": {
      height: "125px",
    },
  },
  liquidLeadrboard: {
    paddingTop: "5px",
    color: "#FFFFFF",
    fontSize: "13px",
  },
  liquidListLeadrboard: {
    color: "#5675D3",
    fontSize: "13px",
  },
  liquidBoldLeadrboard: {
    fontSize: 13,
    fontWeight: "bold",
    "@media (max-width: 480px)": {
      fontSize: 12,
    },
  },
  small: {
    width: 40,
    height: 40,
    border: "2px solid #cd7f32",
  },
  medium: {
    width: 60,
    height: 60,
    border: "2px solid #FFFFFF",
    "@media (max-width: 768px)": {
      width: 40,
      height: 40,
    },
    "@media (max-width: 480px)": {
      width: 40,
      height: 40,
    },
  },
  large: {
    width: 80,
    height: 80,
    border: "2px solid #F9A23D",
  },
  colorGold: {
    color: "#FFFFFF",
    backgroundColor: "#F9A23D",
  },
  colorBronze: {
    color: "#FFFFFF",
    backgroundColor: "#cd7f32",
  },
  wrapKategori: {
    padding: "10px",
  },
  kategori: {
    marginTop: 4,
    marginRight: 4,
    justifyContent: "flex-start",
    alignItems: "center",
  },
  iconKategori: {
    display: "flex",
    justifyContent: "center",
  },
  textKategori: {
    textAlign: "center",
  },
  iconBrand: {
    width: "50px",
  },
  banner: {
    objectFit: "cover",
    width: "100%",
    height: 240,
    "@media (max-width: 768px)": {
      height: 100,
    },
    "@media (max-width: 480px)": {
      height: 100,
    },
  },
  card: {
    height: "100%",
    borderRadius: "10px",
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
  },
  dialogTokoramepoin: {
    padding: "0px !important",
  },
  dialogContentTokoramePoin: {
    paddingTop: "0px !important",
    padding: "0px !important",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  heroTokoramepoin: {
    objectFit: "cover",
    width: "100%",
  },
  wrapHeroTokoramepoin: {
    minHeight: "207px",
    minWidth: "100%",
  },
  wrapButtonCloseTokoramepoin: {
    position: "absolute",
    right: 0,
    padding: 5,
  },
  timeTimer: {
    color: "#FFFFFF",
  },
  containerRegisByOder: {
    backgroundColor: "#5675D3",
  },
  keterTime: {
    color: "#FFFFFF",
    "@media (max-width: 480px)": {
      fontSize: 8,
    },
  },
  rootRmz: {
    display: "flex",
    padding: 10,
    marginBottom: 10,
    marginTop: 10,
  },
  logosrmz: {
    objectFit: "cover",
    width: 180,
    // width: 150,
    height: 68,
    "@media (max-width: 768px)": {
      height: 80,
    },
    "@media (max-width: 480px)": {
      width: 100,
      height: 40,
    },
  },
  imageCollection: {
    objectFit: "cover",
    width: "100%",
    height: 215,
    borderRadius: "10px",
    "@media (max-width: 768px)": {
      height: 100,
    },
    "@media (max-width: 480px)": {
      height: 100,
    },
  },
  coutdownBack: {
    "@media (max-width: 768px)": {
      height: "90px !important",
    },
    "@media (max-width: 480px)": {
      height: "90px !important",
    },
  },
  containerGarisImg: {
    position: "absolute",
    right: 0,
    bottom: "-15px",
    zIndex: 0,
    textAlign:"end"
  },
  imgGaris: {
    "@media (max-width: 480px)": {
      width: "50%",
    },
  },
}));

export default useStyles;
